<section class="bo-auth-card">
  <header class="bo-auth-card__header">
    <h2 class="bo-auth-card__title">{{ title() }}</h2>
    @if (subtitle()) {
      <p class="bo-auth-card__subtitle">{{ subtitle() }}</p>
    }
  </header>
  <div class="bo-auth-card__body">
    <ng-content />
  </div>
</section>
